var map = {
	"./541d2506-9363-4c8b-8646-cfbf6fa7031e.pdf": 2567,
	"./573775ba-db66-4d5c-823f-09dfa78db616.pdf": 2568,
	"./6e063bce-ead8-43d7-9bc6-4e322be4e885.pdf": 2569,
	"./COLA2018001.pdf": 2570,
	"./COLA2018002.pdf": 2571,
	"./COLA2018003.pdf": 2572,
	"./COLA2018004.pdf": 2573,
	"./COLA2018005.pdf": 2574,
	"./COLA2018006.pdf": 2575,
	"./COLA2018007.pdf": 2576,
	"./COLA2018008.pdf": 2577,
	"./Chapter.pdf": 2578,
	"./c7da8588-5302-43fa-9200-368b6ba96eba.pdf": 2579,
	"./doc.pdf": 2580
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2566;


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles ^\.\/.*$
// module id = 2566
// module chunks = 1